import profile from './profile'
import profileEdit from './profileEdit'
import profileDocuments from './profileDocuments'
import consultation from './consultation'
import calculator from './calculator'
import lifeLine from './lifeLine'
import personalPage from './personalPage'
import ownershipDetails from './ownershipDetails'
import paymentDetails from './paymentDetails'
import contractDetails from './contractDetails'
import signingOptions from './signingOptions'
import constructionStages from './constructionStages'

export default {
  profileEdit,
  profileDocuments,
  profile,
  consultation,
  calculator,
  lifeLine,
  personalPage,
  ownershipDetails,
  paymentDetails,
  contractDetails,
  signingOptions,
  constructionStages
}
